import { Button } from '@/components/ui/button';
import { useSignupUrl } from '@/hooks/useSignupUrl';
import { useLandingSectionTracking } from '@/hooks/useLandingSectionTracking';
import { trackLandingCtaClicked } from '@/lib/analytics';
import { useTranslation } from '@/i18n/i18n';

export function BiuraCTA() {
  const sectionRef = useLandingSectionTracking('biura_cta');
  const signupUrl = useSignupUrl({ entityType: 'biuro', source: 'biura_cta' });
  const { t } = useTranslation();

  return (
    <section
      ref={sectionRef}
      className="px-6 md:px-8 py-16 bg-background"
      aria-labelledby="biura-cta-heading"
    >
      <div className="max-w-6xl mx-auto">
        <h2 id="biura-cta-heading" className="text-3xl md:text-4xl font-semibold tracking-tight">
          {t('biura.cta.heading')}
        </h2>
        <p className="mt-3 text-lg text-muted-foreground max-w-2xl">{t('biura.cta.subheading')}</p>
        <Button size="lg" className="mt-8 h-14 px-8 font-bold rounded-full" asChild>
          <a
            href={signupUrl}
            onClick={() =>
              trackLandingCtaClicked('biura_final_cta', t('biura.cta.button'), {
                entity_type: 'biuro',
              })
            }
          >
            {t('biura.cta.button')}
          </a>
        </Button>
      </div>
    </section>
  );
}
